import React from 'react';


const AmenidadButton = (
    {nombre, icono, handleClickButton, stateBtnSelected, mapaSeleccionado}
    ) => {
    return (
            nombre !== "General View" && nombre !== "Piso 2" && nombre !== "Piso 4" && nombre !== "Piso 6" && nombre !== "Piso 8" && nombre !== "Piso 10" ?
            <button /*style={ stateBtnSelected===nombre ? {"background":"#5e5958", color: '#ffffff'}:{ color: 'rgba(95,89,88,1)'}} */
            className={stateBtnSelected===nombre ? "btn-sidebar selected" : "btn-sidebar"}
            onClick={(event) => handleClickButton( {nombre:nombre, mapa:mapaSeleccionado, icono})} >
                {stateBtnSelected != nombre ? <img src={icono[nombre]}/> : <img src={icono[nombre + '2']}/>}
                <span>{nombre}</span>
            </button>: <></>
            
    );
};


export default AmenidadButton;